<!-- PDF Preview -->
@if (isPdf) {
  <div class="pdf-dialog-wrapper">
    <div class="pdf-dialog-header">
      <button mat-icon-button class="close-btn" (click)="dialogRef.close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="pdf-dialog-content">
      <pdf-viewer
        [src]="pdfUrl"
        [rotation]="0"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        [show-all]="true"
        [autoresize]="true"
        [zoom-scale]="'page-width'"
      >
      </pdf-viewer>
    </div>
  </div>
}

<!-- Image Preview -->
@else {
  <mat-dialog-content>
    <button mat-icon-button class="close-btn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
    <img
      [src]="isServer ? (data.image | useHttpImgSrc: data.query) : data.image"
      alt="flag"
      onerror="this.src='assets/images/image-loader.gif'"
    />
  </mat-dialog-content>
}
